import { Typography, Box } from '@mui/material';
import React from 'react'
import { dataConstants } from '../../../../constants';
import { getRandomStr } from '../../../../helpers';

const { ECO_SECTION_CODES } = dataConstants || {};

function RealGDP({ data }) {
  //gdp break
  const gdpBreak = data && data.length > 0 ? data.find(d => d.section_code === ECO_SECTION_CODES.GLA_GDP_BREAK) : undefined;
  const gdpBreakData = gdpBreak && gdpBreak.tabData && gdpBreak.tabData.length > 0 ? gdpBreak.tabData : gdpBreak;

  //current gdp info
  const realGdpCol = gdpBreak && gdpBreak.settings && gdpBreak.settings.cols ? gdpBreak.settings.cols.find(d => d.isTitle) : undefined;
  const realGdp = gdpBreakData && realGdpCol ? gdpBreakData.find(d => d.code === realGdpCol.code) : undefined;
  //gdpData = gdpData && gdpData.length >

  return (
    <>
      {realGdp && gdpBreak &&
        <Box component="div" className="col-md-4" sx={{ height: '100%', }}>
          <Box component="div" className="section" sx={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', px: '1.57rem !important', color: '#174c86 !important', }} >
            <Typography variant="h2" className="option-title" sx={{ fontSize: '1rem !important', fontWeight: '600', color: 'inherit' }} >
              {realGdpCol.desc}
            </Typography>
            <Typography variant="h2" className="option-title" sx={{ fontSize: '1rem !important', fontWeight: '600', color: 'inherit' }} >
              {realGdp.value}%
            </Typography>
          </Box>
          {gdpBreak.settings.order.map(s => {
            const item = gdpBreakData.find(d => d.code === s);
            const col = gdpBreak.settings.cols.find(d => d.code === s && !d.isTitle);
            return (item && (item.value !== undefined && item.value !== null) && col ?
              <Box key={getRandomStr(3)} className="eco-break-item" sx={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', mb: 1.4, px: 3, mt: 2 }} >
                <Typography variant="body1" className="eco-desc" sx={{ fontSize: '.87rem' }} >
                  {col.desc || item.description}
                </Typography>
                <Typography variant="body1" className="eco-val" sx={{ fontSize: '.87rem' }} >
                  {col.isPct ? `${item.value}%` : item.value}
                </Typography>
              </Box>
              : null);
          })}
        </Box>}
    </>
  )
}

export default RealGDP
